// Un active nulo en la BD se trata como activo
export const isActive = (employee: any) => employee?.active !== false;

export const fullName = (employee: any) =>
  employee?.display_name || [employee?.name, employee?.surname].filter(Boolean).join(" ");

// Props comunes de las pestañas de Gestión de usuarios
export type UsersTabProps = {
  selfId?: number; // usuario actual (/employee/me): no puede desactivarse, borrarse ni cambiarse el rol
  selfRolId?: number; // su rol: no puede quitarse gestionar_usuarios
  createOpen: boolean; // botón "Añadir" de la cabecera de la página
  onCreateClose: () => void;
  onSelfChanged: () => void; // refrescar el usuario actual si le afecta un cambio
};
